export default "__VITE_ASSET__8b5636fd__"